/*
 * Copyright 2026 Sony Corporation
 */
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import { Link as RouterLink, Outlet, useMatch } from 'react-router-dom';

import { useAuth } from '../contexts/auth-context';

import { DashboardIcon, DevicesIcon, ProjectsIcon } from './icons';

export const AppShell = () => {
  const { email, signOut } = useAuth();
  // A project fills the window with its panels; the other pages are a centred column.
  const onProject = useMatch('/projects/:projectId') !== null;

  return (
    <Box sx={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Toolbar variant="dense" sx={{ gap: 1 }}>
          <Button component={RouterLink} to="/runtimes" color="inherit" startIcon={<DevicesIcon />}>
            Runtimes
          </Button>
          <Button component={RouterLink} to="/projects" color="inherit" startIcon={<ProjectsIcon />}>
            Projects
          </Button>
          <Button component={RouterLink} to="/dashboard" color="inherit" startIcon={<DashboardIcon />}>
            Dashboard
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Typography variant="body2" color="text.secondary">
            {email}
          </Typography>
          <Button color="inherit" onClick={signOut}>
            Sign out
          </Button>
        </Toolbar>
      </AppBar>
      {onProject ? (
        <Box component="main" sx={{ flex: 1, minHeight: 0, p: 2, overflow: { xs: 'auto', md: 'hidden' } }}>
          <Outlet />
        </Box>
      ) : (
        <Box component="main" sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <Container maxWidth="lg" sx={{ py: 3 }}>
            <Outlet />
          </Container>
        </Box>
      )}
    </Box>
  );
};
